import React, { Component } from 'react'
import Title from '../components/Title'
import './Home.css'

class Home extends Component {
  render () {
    return (
      <div className='home'>
        <Title title='Inicio' />
        <div className='home__content'>
          <p>Crea, administra y consulta resultados de quinielas.</p>
        </div>
      </div>
    )
  }
}

export default Home
